import { Component, OnInit } from '@angular/core';

import { LazyLoadEvent, SelectItem, MessageService, FilterMetadata, FilterMatchMode } from 'primeng/api';
import { Table } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

import { BillingDataService } from '../../data-services/billing.service';

import { SecurityUser } from '../../security/security.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { BillingDetailComponent } from './billing.detail.component';
import { PrimeNG } from 'primeng/config';

interface DropDown {
  name: string;
  code: string;
}
@Component({
  selector: 'app-billing-report',
  templateUrl: './billing.report.html',
  styleUrls: ['./billing.report.css'],
  providers: [MessageService],
  imports: [FormsModule, CommonModule, TableModule, SelectModule, MultiSelectModule, BillingDetailComponent, TooltipModule]
})
export class BillingReportComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  isAuthenticated: boolean;

  constructor(private billingDataService: BillingDataService,
    private messageService: MessageService)
  { }

  requisitions;
  totalRecords: number;
  cols: any[];
  filters: { [s: string]: FilterMetadata[] } = { };
  loading: boolean;
  selectedStatus: SelectItem;
  globalFilter: string = '';
  billingStatusList: any[] = [
    { label: 'Pre Billing', value: 'Pre Billing' },
    { label: 'Billing Hold', value: 'Billing Hold' },
    { label: 'Not Billable', value: 'Not Billable' },
    { label: 'Express Pay', value: 'Express Pay' },
    { label: 'Sent to ADM', value: 'Sent to ADM' },
    { label: 'Charge Created', value: 'Charge Created' },
    { label: 'Charge Updated', value: 'Charge Updated' },
    { label: 'Claim Submitted', value: 'Claim Submitted' },
    { label: 'AP/MR Submitted', value: 'AP/MR Submitted' },
    { label: 'Claim Response', value: 'Claim Response' },
    { label: 'Claim Denied', value: 'Claim Denied' },
    { label: 'Claim Paid', value: 'Claim Paid' },
    { label: 'Invoice Pending', value: 'Invoice Pending' },
    { label: 'Invoice Processing', value: 'Invoice Processing' },
    { label: 'Invoiced', value: 'Invoiced' },
    { label: 'Invoice Paid', value: 'Invoice Paid' },
    { label: 'Write Off', value: 'Write Off' },
  ]
  booleanFilterList: any[] = [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ]

  billingSubStatusList: any[] = [];

  labStatusList: any[] = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'Processing', value: 'Processing' },
    { label: 'In Transit to Lab', value: 'In Transit to Lab' },
  ]
  dontLazyLoad: boolean = false;

  async ngOnInit() {
    this.loading = true;
    this.billingSubStatusList = [];
    this.billingDataService.getSubstatuses().subscribe((data: any) => {
      for (const s of data) {
        this.billingSubStatusList.push({ label: s, value: s });
      }
      this.cols = [
        { field: 'Accession', header: 'SID', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'Client', header: 'Client', type: 'text', filter: 'text', sortable: true, width: '3%' },
        //{ field: 'ClientCode', header: 'Client Code', type: 'text', filter: 'text', sortable: true, width: '3%' },
        //{ field: 'ProviderNPI', header: 'NPI', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'ProviderName', header: 'Provider', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'Patient', header: 'Patient', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'DOB', header: 'DOB', type: 'date', filter: 'date', sortable: true, width: '150px' },
        { field: 'LabTest', header: 'Lab Test', type: 'text', filter: 'text', sortable: true, width: '3%' },
        //{ field: 'LabCode', header: 'Test Code', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'CPT', header: 'CPT', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'DOS', header: 'DOS', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'DateCompleted', header: 'Resulted', type: 'date', filter: 'text', sortable: true, width: '3%' },
        { field: 'BillingStatus', header: 'Bill Status', type: 'text', filter: 'list', filterList: this.billingStatusList, sortable: true, width: '3%' },
        { field: 'DateBillingStatus', header: 'Status Date', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'SubStatus', header: 'Sub Status', type: 'text', filter: 'list', filterList: this.billingSubStatusList, sortable: true, width: '3%' },
        { field: 'IsExpressPay', header: 'Express Pay?', type: 'bool', filter: 'boolean', sortable: true, width: '3%' },
        { field: 'IsInstitutionalBill', header: 'Institutional?', type: 'bool', filter: 'boolean', sortable: true, width: '3%' },
        //{ field: 'ExpectedAmount', header: 'Expected $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'Balance', header: 'Balance $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'Payment', header: 'Payment $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'WriteDownAmount', header: 'Write Down $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'FinancialClass', header: 'Financial Class', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'InsuranceCode', header: 'Insurance Code', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'InsuranceName', header: 'Insurance', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'InsuranceBalance', header: 'Ins Bal $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'InstitutionalBalance', header: 'Inst Bal $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'PatientBalance', header: 'Pat Bal $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        //{ field: 'TotalPayment', header: 'Tot Payment $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'InsurancePayment', header: 'Ins Pay $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'InstitutionalPayment', header: 'Inst Pay $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'PatientPayment', header: 'Pat Pay $', type: 'currency', filter: 'currency', sortable: true, width: '3%' },
        { field: 'FirstClaimDate', header: 'First Claim', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'LastClaimDate', header: 'Last Claim', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'PaymentDate', header: 'Payment', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'LastLogDate', header: 'Last Log', type: 'date', filter: 'date', sortable: true, width: '3%' },
        { field: 'LastLogActivity', header: 'Last Activity', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'LastReason', header: 'Reason', type: 'textO', filter: 'text', sortable: true, width: '3%' },
        { field: 'AppealSubmitted', header: 'Appealed?', type: 'bool', filter: 'boolean', sortable: true, width: '3%' },
        { field: 'MRSubmitted', header: 'MR Sub?', type: 'bool', filter: 'boolean', sortable: true, width: '3%' },
        { field: 'ICN', header: 'ICN', type: 'text', filter: 'text', sortable: true, width: '3%' },
        { field: 'Insurance', header: 'LT Ins', type: 'textO', filter: 'text', sortable: true, width: '3%' },
      ];

    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading Substatus List ', detail: 'Failed: ' + err.error });
    });

    this.filters = {
    };

    this.loading = true;
  }

  public applyGlobalFilter(value: string, reqlist) {
    reqlist.filterGlobal(value, 'contains');
  }

  public dropdownFilter(filter: (a: string) => void, value: string) {
    this.dontLazyLoad = true;
    filter(value);
    this.dontLazyLoad = false;
  }

  public multiSelectFilter(filter: (a: string) => void, value: string) {
    this.dontLazyLoad = true;
    filter(value);
    this.dontLazyLoad = false;
  }

  public loadReportLazy(event: LazyLoadEvent) {
    if (this.dontLazyLoad) {
      return;
    }
    this.loading = true;
    this.billingDataService.getReport(event).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.requisitions = data.rows;
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading Report ', detail: 'Failed: ' + err.error });
      this.totalRecords = 0;
      this.requisitions = [];
      this.loading = false;
    });
  }

  clear(table: Table) {
    table.clear();
    this.filters = {};
  }

  public downloadReport(event: LazyLoadEvent, table: Table) {
    if (this.dontLazyLoad) {
      return;
    }
    this.loading = true;
    const e: { first: number, rows: number, filters: any } = {first: 0, rows: 32655, filters: this.filters};

    this.billingDataService.getReportXLSX(e).subscribe((response: any) => {
      this.loading = false;
      if (response) {
        let file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');

        // Create an object URL pointing to the blob
        const url = window.URL.createObjectURL(file);

        link.href = url;
        link.download = "BillingReport.xlsx";

        // Append to body, trigger click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Release the object URL memory allocation
        window.URL.revokeObjectURL(url);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'XSLX is not available' });
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading Report ', detail: 'Failed: ' + err.error });
      this.totalRecords = 0;
      this.requisitions = [];
      this.loading = false;
    });
  }


}
